import React, { useCallback, useState } from "react";
import "../sass/layout/_signatureJourneys.scss";
import "../sass/main.scss";
import { useNavigate } from "react-router-dom";
import LazyImage from "./LazyImage.js";
import { useDetectOverflow } from "../hooks/useDetectOverflow.js";

export const NewJourneyCard = ({
  dest,
  index,
  setHighlightedIndex,
  img,
  navTo,
  navToFunction,
  shouldRenderEnquireButton,
  currentCountry
}) => {
  const navigate = useNavigate();
  const [changeTextColor, setChangeTextColor] = useState(false);

  const [ref] = useDetectOverflow();

  const toggleHighlight = (index) => {
    setChangeTextColor(true);
    setHighlightedIndex(index);
  };

  const resetHighlight = () => {
    setChangeTextColor(false);
    setHighlightedIndex(null);
  };

  const onClick = useCallback(
    () => {
      if (navTo) {
        navigate(navTo, { replace: "true " });
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        })
      }

      return null
    },
    [navTo, navigate]
  );



  return (
    <div
      onClick={onClick}
      key={index}
      className="jr-card"
      onMouseEnter={() => toggleHighlight(index)}
      onMouseLeave={() => resetHighlight()}
    >
      <LazyImage
        notFullHeight={true}
        component={
          <div
            className="jr-card-upper"
            style={{
              backgroundImage: `url(${img})`,
              backgroundSize: "cover",
            }}
          />
        }
      />
      <div onClick={onClick} className="jr-card-lower">
        <p style={{ color: changeTextColor && "#000" }}
          className="jr-card-lower-heading-sub">{dest.sub_description === "" ? "" : dest.description}</p>
        <div
          ref={ref}
          style={{
            flexDirection: "column",
          }}
          className="jr-card-lower-heading-description-container">
          <p style={{ color: changeTextColor && "#000" }}>
            {dest.sub_description === "" ? dest.description : dest.sub_description}
          </p>

          <p style={{ textTransform: "uppercase", fontSize: "1rem", color: changeTextColor && "#000" }}>
            {currentCountry && currentCountry.toLowerCase() === "srilanka" ? "sri lanka" : currentCountry}
          </p>
        </div>

      </div>
    </div>
  );
};
